"use client";

import { Trans, useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight, CalendarCheck } from "lucide-react";

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 px-6">
      <div className="container mx-auto">
        <div className="relative overflow-hidden rounded-3xl border-2 border-border bg-gradient-to-br from-primary/20 via-background to-accent/20 p-12 md:p-20">
          <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-primary/30 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-accent/30 blur-3xl" />

          <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6">
            <h2 className="font-heading text-4xl md:text-6xl font-bold leading-tight">
              <Trans
                i18nKey="cta.title"
                components={{ gradient: <span className="text-gradient" /> }}
              />
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground">
              {t("cta.subtitle")}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <Button variant="hero" size="lg" asChild>
                <a href={process.env.NEXT_PUBLIC_BOOKING_URL}>
                  <CalendarCheck aria-hidden="true" />
                  {t("cta.bookDemo")}
                </a>
              </Button>
              <Button variant="default" size="lg" className="group" asChild>
                <a href={process.env.NEXT_PUBLIC_REGISTER_URL}>
                  {t("cta.startNow")}
                  <ArrowRight className="transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
